import axios from "./config";
import { API } from "./api";
import { getlaborCodeList } from "./siteRepo.service";

export const createQuoteService = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.createQuote}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const addFloorPlanService = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.addFloorPlan}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const deleteFloorPlanService = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.deleteFloorPlan}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const floorPlanDetailsService = async (floorId, quoteId) => {
  return (
    await axios(
      `${API.priceQuote.root}${API.priceQuote.floorPlanDetails.replace("{0}", floorId).replace("{1}", quoteId)}`,
    )
  ).data;
};

export const laborCodeDeleteService = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.laborCodeDelete}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const productDeleteService = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.productDelete}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const prcService = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.prc}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const getPriceService = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.getPrice}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const laborCodeService = async (storeNum) => {
  return axios
    .get(`${API.priceQuote.root}${API.priceQuote.laborCodes.replace("{0}", storeNum)}`)
    .then((res) => {
      if (!res.data?.length) {
        return getlaborCodeList()
          .then((resp) => {
            return resp;
          })
          .catch((err) => {
            return err;
          });
      }
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      if (!storeNum) {
        return getlaborCodeList()
          .then((resp) => {
            return resp;
          })
          .catch((err) => {
            return err;
          });
      } else {
        Promise.reject(err);
      }
    });
};

export const emailService = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.email}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const pdfService = async (quoteId) => {
  return axios(`${API.priceQuote.root}${API.priceQuote.pdfData.replace("{0}", quoteId)}`)
    .then((res) => Promise.resolve(res.data))
    .catch((err) => Promise.reject(err));
};

export const searchQuoteService = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.searchQuote}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const viewQuoteService = async (quoteId) => {
  return axios
    .get(`${API.priceQuote.root}${API.priceQuote.viewQuote.replace("{0}", quoteId)}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const emailNotificationService = async (quoteId) => {
  return axios
    .get(`${API.priceQuote.root}${API.priceQuote.emailNotification.replace("{0}", quoteId)}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const duplicateQuoteService = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.duplicateQuote}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const checkDuplicateNameService = async (quoteName) => {
  return axios
    .get(`${API.priceQuote.root}${API.priceQuote.checkDuplicateName.replace("{0}", quoteName)}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const catergoryListService = async () => {
  return axios
    .get(`${API.priceQuote.root}${API.priceQuote.prodCategories}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const bulkEditSearchService = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.bulkEditSearch}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const bulkEditProductService = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.bulkUpdateProducts}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const bulkEditLaborService = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.bulkUpdateLabor}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const getBulkProductsService = async (payload) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.getBulkProductsData}`, payload)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const bulkLaborSearch = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.laborSearch}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const createPRCService = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.createPRC}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const updatePRCService = async (body) => {
  return axios
    .post(`${API.priceQuote.root}${API.priceQuote.updatePRC}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const salesRepService = async (acc, job) => {
  return (await axios(`/fc-price-quote/salesRep/${acc}/${job}`)).data;
};

export const getJobDetailsService = async (accNum) => (await axios.get(`/fc-price-quote/accounts/${accNum}/jobs`)).data;
